export type {
  FirstResponderValidationRequest as FirstResponderStatusRequest,
  FirstResponderValidationResponse as FirstResponderDetails,
} from '@generated/models'

export {FirstResponderAuthStatus} from '@generated/models'
